import React from 'react';
import PropTypes from 'prop-types';
import { Parser } from 'html-to-react';

import Replies from '../../../../components/comments/replies';
import TicketService from '../../../../services/ticket.service';
import AttachedFile from '../../../../components/files/attachedFile';
import UserService from '../../../../services/user.service';

const htmlToComponents = new Parser().parse;

const Ticket = ({
  t,
  formData,
  currentUser,
  markAsResolved,
  imgSrc,
  currentTicket,
  backgroundColor,
}) => (
  <React.Fragment>
    { formData && currentTicket &&
      <div className="tictabs tictabs1">
        <div className="choseprty boxs">
          <div className="lefttD">
            <div className="boxs">
              <h6><p className="text-lowercase">{t('By')}</p> {formData.creator ? formData.creator : 'Someone interesting' }<span>{formData.last_replay_at || formData.created_at}</span></h6>
            </div>
          </div>
          <div className="righttD">
            <ul className="ticDul">
              <li><a className={formData.status.toLowerCase()}>{formData.status}</a></li>
            </ul>
          </div>
        </div>
        <div className="boxs cmntwfile">
          <div className="boxs fdbck">
            <p className="fontmulisemi">{htmlToComponents(formData.message)}</p>
          </div>
          {formData.files && formData.files.length ?
            <div className="boxs fontmulisemi Attchfilefdbck Attchfiletckt Attchfiletckt3">
              <div className="leftfbw">
                <div className="boxs">
                  <span className="attchfilefbck ">{t('Attached files')}<span>( { formData.files.length} )</span>:</span>
                </div>
              </div>
              <div className="middlefbw">
                <div className="boxs">
                  {formData.files ? formData.files.map(file => (
                    <div key={file.id}>
                      <AttachedFile
                        file={file}
                        files={formData.files}
                        viewOnly
                        mult
                      />
                    </div>
                )) : ''}
                </div>
              </div>
            </div> : ''}

          <Replies
            model_id={formData.id}
            backgroundColor={backgroundColor}
            model_name={TicketService.modelName}
            markAsResolved={currentTicket.status !== TicketService.STATUS_RESOLVED
              && formData.created_by === currentUser ? markAsResolved : ''}
          />
        </div>
      </div>
      }
  </React.Fragment>
);

Ticket.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Ticket;



// WEBPACK FOOTER //
// ./src/views/modules/ticket/ticket/Ticket.jsx